import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

// Pulse list query

export const listQuery = graphql(`
    query AppPulseListQuery {
        pulseList {
            id
            name
            createdDatetime
            question1
            question2
        }
    }
`);

// Pulse query

export const pulseQuery = graphql(`
    query AppPulseQuery($id:ID!) {
        pulse(id:$id) {
            id
            name
            createdDatetime
            question1
            question2
            link
            qrCode
            pulseAnswers {
                id
                createdDatetime
                answer1
                answer2
            }
        }
    }
`);

export type IPulse = ResultOf<typeof pulseQuery>["pulse"];

// Create pulse mutation

export const createMutation = graphql(`
    mutation AppPulseCreateMutation($data: PlayerPulseCreateData!) {
        pulseCreate(data:$data) {
            error
            pulse {
                id
            }
        }
    }
`);

// Suggested pulse questions query

export const questionsQuery = graphql(`
    query AppPulseSuggestedQuestionsQuery {
        pulseSuggestedQuestions {
            id
            content
        }
    }
`);

// Rename pulse mutation

export const renameMutation = graphql(`
    mutation AppPulseRenameMutation($data:PlayerPulseRenameData!) {
        pulseRename(data:$data) {
            error
            pulse {
                id
            }
        }
    }
`);
